import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const PodcastList: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <BooksList
            category_label={t("พอดแคสต์")}
            category_path={routeName.e_library.podcast}
            category_pathname_label={routeName.e_library.podcast_list}
            library_category_name={ELibraryCategory.PODCAST}
            path_detail={routeName.e_library.podcast_detail}
            allow_shadow={true}
            allow_view_audio={true}
        />
    )
}

export default PodcastList